import axios from "axios";
export const BaseURL = process.env.REACT_APP_APIS_KEY;
//"https://qcfmp5gp-3002.uks1.devtunnels.ms/api/v1";

//  "https://real-properties-f93caf3922f0.herokuapp.com/api/v1";
//https://qcfmp5gp-3002.uks1.devtunnels.ms/api/v1
//https://prepared-sponge-loved.ngrok-free.app/api/v1
//https://alien-better-viper.ngrok-free.app/api/v1
//https://realpropertybackend.onrender.com/api/v1

axios.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") &&
      JSON.parse(localStorage.getItem("token"));

    config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
